import React from 'react';

import MarkdownLinkPreview from '../components/markdownLinkPreview';
import MarkdownMention from '../components/markdownMention';
import MarkdownHashtag from '../components/markdownHashtag';
import MarkdownLink from '../components/markdownLink';

import styles from '../styles/uikitContentMarkdown.module.scss';

export default ({
  shouldTruncateLink,
  onMentionClicked,
  onHashtagClicked,
  onLinkClicked,
  isReviewing,
  getLinkPreviewData,
  LinkPreview,
  linkPreviewHrefPrefix,
  linkPreviewContentAlignment,
  linkTarget,
  customRenderers = {},
}) => ({
  link: (customRendererProps) => {
    const isMention = customRendererProps.href === 'mention';
    const isHashtag = customRendererProps.href === 'hashtag';
    const isPreview = customRendererProps.href === 'preview';

    if (isMention) {
      const [name, id] = customRendererProps.children[0].props.value.split('-id:');

      if (!id) {
        return `@${name}`;
      }

      return <MarkdownMention name={name} id={id} onClick={onMentionClicked} />;
    }

    if (isHashtag) {
      const text = customRendererProps.children[0].props.value;

      return <MarkdownHashtag text={text} onClick={onHashtagClicked} />;
    }

    if (isPreview) {
      const [text, id] = customRendererProps.children[0].props.value.split('-id:');

      return (
        <MarkdownLinkPreview
          text={text}
          id={id}
          getLinkPreviewData={getLinkPreviewData}
          LinkPreview={LinkPreview}
          hrefPrefix={linkPreviewHrefPrefix}
          previewContentAlignment={linkPreviewContentAlignment}
          linkTarget={linkTarget}
        />
      );
    }

    return (
      <MarkdownLink
        shouldTruncateLink={shouldTruncateLink}
        link={customRendererProps.href}
        linkTarget={linkTarget}
        content={customRendererProps.children}
        isReviewing={isReviewing}
        onClick={onLinkClicked}
      />
    );
  },
  linkReference: (customRendererProps) => {
    if (!customRendererProps.href) {
      return (
        <>
          [
          {customRendererProps.children}
          ]
        </>
      );
    }
    return (
      <MarkdownLink
        shouldTruncateLink={shouldTruncateLink}
        link={customRendererProps.href}
        linkTarget={linkTarget}
        content={customRendererProps.children}
        isReviewing={isReviewing}
        onClick={onLinkClicked}
      />
    );
  },
  image: (customRendererProps) => {
    if (customRendererProps.src) {
      return (
        <a
          href={customRendererProps.src}
          className={styles.imageLink}
          target={linkTarget}
          rel="noopener noreferrer"
        >
          <img src={customRendererProps.src} alt={customRendererProps.alt} />
        </a>
      );
    }
    return null;
  },
  ...customRenderers,
});
